import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Layout from '../../components/ui/Layout';
import Card from '../../components/ui/Card';
import PageHeader from '../../components/ui/PageHeader';
import {
  IconTractor,
  IconShieldCheck,
  IconUsers,
  IconTool,
  IconDroplet,
  IconLeaf,
  IconCurrencyPound,
  IconFileText,
  IconArrowRight,
} from '@tabler/icons-react';

const REPORTS = [
  {
    key: 'fleet',
    title: 'Fleet health',
    description: 'Overview of all machines — status, hours, service due, blocked assets',
    icon: IconTractor,
    colour: '#185FA5',
    path: '/reports/fleet',
  },
  {
    key: 'compliance',
    // ComplianceReport.js is still a placeholder, so the card is hidden
    // rather than leading somewhere blank. Delete this line to bring it back.
    hidden: true,
    title: 'Compliance report',
    description: 'Daily check completion rates, failed checks, incident summary',
    icon: IconShieldCheck,
    colour: 'var(--color-success)',
    path: '/reports/compliance',
  },
  {
    key: 'qualifications',
    title: 'Qualification status',
    description: 'Staff qualifications overview — valid, expiring and expired tickets',
    icon: IconUsers,
    colour: 'var(--color-brand)',
    path: '/reports/qualifications',
  },
  {
    key: 'service-due',
    title: 'Service due',
    description: 'Machines approaching or overdue their next service by hours or date',
    icon: IconTool,
    colour: 'var(--color-warning)',
    path: '/reports/service-due',
  },
  {
    key: 'fuel',
    title: 'Fuel usage',
    description: 'Derv consumption by machine and site, fill history and trends',
    icon: IconDroplet,
    colour: 'var(--color-brand)',
    path: '/reports/fuel',
    feature: 'derv',
  },
  {
    key: 'carbon',
    title: 'Carbon emissions',
    description: 'CO₂ emissions calculated from fuel consumption — DEFRA standard',
    icon: IconLeaf,
    colour: 'var(--color-success)',
    path: '/reports/carbon',
    feature: 'carbonReporting',
  },
  {
    key: 'cost',
    title: 'Cost per machine',
    description: 'Total cost of ownership — service, repair, fuel and depreciation',
    icon: IconCurrencyPound,
    colour: 'var(--color-text-primary)',
    path: '/reports/cost',
  },
  {
    key: 'insurance',
    title: 'Insurance pack',
    description: 'Generate a full machine profile PDF for insurance claims',
    icon: IconFileText,
    colour: '#534AB7',
    path: '/reports/insurance',
  },
];

export default function ReportsHub() {
  const navigate = useNavigate();
  const { hasFeature } = useAuth();

  const available = REPORTS.filter(r => !r.hidden && (!r.feature || hasFeature(r.feature)));

  return (
    <Layout>
      <div style={{ padding: 'var(--main-padding)' }}>
        <PageHeader
          title="Reports"
          subtitle="Compliance, fleet health and operational insights"
        />
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: 12 }}>
          {available.map(report => {
            const Icon = report.icon;
            return (
              <Card
                key={report.key}
                onClick={() => navigate(report.path)}
                hover
              >
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14 }}>
                  <div style={{ width: 40, height: 40, borderRadius: 'var(--radius-lg)', background: report.colour + '18', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    <Icon size={20} color={report.colour} stroke={1.5} />
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 15, fontWeight: 400, color: 'var(--color-text-primary)', marginBottom: 4 }}>{report.title}</div>
                    <div style={{ fontSize: 12, color: 'var(--color-text-tertiary)', lineHeight: 1.5 }}>{report.description}</div>
                  </div>
                  <IconArrowRight size={16} color="var(--color-text-tertiary)" stroke={1.5} style={{ flexShrink: 0, marginTop: 2 }} />
                </div>
              </Card>
            );
          })}
        </div>
      </div>
    </Layout>
  );
}